import { Component, Input, OnInit } from '@angular/core';
import { SaComponent, CurrencyFormatService } from 'smartauction-frontend-micro-library';
import { take } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';
import { DateUtilsService } from 'remarketing-angular-library';
import { PreviousOffers } from '../../../models/offer-history.model';
import { CommonModule } from '@angular/common';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ParseStringPipe } from '../../../ui/pipes/parse-string/parse-string.pipe';


@Component({
    selector: 'app-collapsable-offer-history',
    templateUrl: './collapsable-offer-history.component.html',
    styleUrls: ['./collapsable-offer-history.component.scss'],
    imports: [CommonModule, CollapseModule, ParseStringPipe]
})
export class CollapsableOfferHistoryComponent extends SaComponent implements OnInit {
  @Input() previousOffers: PreviousOffers;
  @Input() title: string;
  @Input() variant: 'button' | 'link' = 'button';
  @Input() scrollable = false;
  offerIndex = 0;
  commentsText = '';
  isOpen = false;

  CONSTANTS = {
    textDate: '',
    labelOfferAmount: '',
    labelBuyerComment: '',
    labelSellerComment: ''
  };

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly dateUtilService: DateUtilsService,
    private readonly currencyFormatService: CurrencyFormatService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  formatDate(date) {
    return this.dateUtilService.localizeDate(date);
  }

  formatCurrency(currency, withCents) {
    return this.currencyFormatService.formatCurrency(currency, withCents);
  }

  offerTime(date) {
    return this.dateUtilService.localizeTime(date, true);
  }

  getCommentLabel(role: string) {
    return role === 'SELLER' ? this.CONSTANTS.labelSellerComment : this.CONSTANTS.labelBuyerComment;
  }

  onOpenChange() {
    this.isOpen = !this.isOpen;
  }

  getTranslations() {
    const keyParams = {
      vehicles: {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(take(1))
      .subscribe(
        (translate: any[]) => {
          this.CONSTANTS.labelOfferAmount = translate[0].offerHistory.labelOfferAmount;
          this.CONSTANTS.textDate = translate[0].offerHistory.textDate;
          this.CONSTANTS.labelBuyerComment = translate[0].offerHistory.labelBuyerComment;
          this.CONSTANTS.labelSellerComment = translate[0].offerHistory.labelSellerComment;
        },
        error => {
          console.log(error);
        }
      );
  }

  get attrId() {
    return this.previousOffers.offersByDate[this.previousOffers.dates[0]][0].offerUuid;
  }
}
